export function toBase64(value: string): string {
  return btoa(value);
}
